// Field Command's URL. On AAN's production hosts we always use the real subdomain so a
// preview host in .env can never ship to a live customer; anywhere else the env wins.
const PROD_AAN_HOSTS = ['allamericannotice.com', 'www.allamericannotice.com'];
const PROD_FIELD_URL = 'https://field.allamericannotice.com';

const resolve = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (PROD_AAN_HOSTS.includes(host)) return PROD_FIELD_URL;
  return process.env.REACT_APP_FIELD_APP_URL || PROD_FIELD_URL;
};

export const FIELD_APP_URL = resolve();

export const fieldAppUrl = (path = '') => `${FIELD_APP_URL.replace(/\/$/, '')}${path}`;

// ─── Visibility switch (Oct 2026) ───
// Field Command is hidden from the public site and the client portal until the owner says it's
// ready. Nothing is deleted and the APIs keep serving, so the companion app and the demo account
// are unaffected — set REACT_APP_SHOW_FIELD_COMMAND=true to bring every surface back at once.
export const FIELD_COMMAND_PUBLIC = process.env.REACT_APP_SHOW_FIELD_COMMAND === 'true';

const ACTIVE_FIELD_STATUSES = ['active', 'comped', 'trialing', 'past_due'];

/** Someone already using Field Command keeps their way in, whatever the switch says. */
export const showFieldCommandFor = (user) => FIELD_COMMAND_PUBLIC
  || Boolean(user?.field_app_enabled)
  || ACTIVE_FIELD_STATUSES.includes(user?.field_plan_status);

